export default __webpack_public_path__ + "static/media/course.faed3fd2.svg";